module.exports = __webpack_public_path__ + "img/hw-s111.671584c9.svg";